<div class="frequency-view-chart-filters-containers">
  <div #chartFiltersContainer
      class="container-fluid pe-1">
    <div class="row px-0 py-2 border-bottom">
      <div class="col">
        <asax-frequency-view-frequency-view-chart-filter-molecules [chartInput]="moleculesChartInput"
                                                                  [value]="moleculesFilterValue | async"
                                                                  (outFilter)="onOutFilter($event)">
        </asax-frequency-view-frequency-view-chart-filter-molecules>
      </div>
      <div class="col">
        <asax-frequency-view-frequency-view-chart-filter-lines [chartInput]="linesChartInput"
                                                              [value]="linesFilterValue | async"
                                                              (outFilter)="onOutFilter($event)">
        </asax-frequency-view-frequency-view-chart-filter-lines>
      </div>
      <div class="col">
        <asax-frequency-view-frequency-view-chart-filter-redshift [chartInput]="redshiftChartInput"
                                                                  [value]="redshiftFilterValue | async"
                                                                  [redshiftEstimated]="redshiftEstimated | async"
                                                                  (outFilter)="onOutRedshiftFilter($event)"
                                                                  (outRedshiftMode)="onOutRedshiftMode($event)">
        </asax-frequency-view-frequency-view-chart-filter-redshift>
      </div>
    </div>
  </div>
</div>


